module.exports = __webpack_public_path__ + "static_pc/img/16.9731db66.png";